<template>
	<div id="app">
		<a-config-provider :locale="locale">
			<a-spin :spinning="LOADING" size="large" tip="加载中...">
				<router-view v-if="isRouterAlive" />
			</a-spin>
		</a-config-provider>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { getDict, getBaseDepts } from '@/api/user'
import { getRandomAesKey, ls, decrypt } from '@/utils/tool'
import { getInfo } from '@/api/user'
import { removeToken, setToken } from '@/utils/auth'
export default {
	computed: {
		...mapState(['LOADING']),
	},
	data() {
		return {
			locale: zhCN,
			isRouterAlive: true,
		}
	},
	provide() {
		//父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
		return {
			reload: this.reload,
		}
	},
	async created() {
		this.getDicts()
		if (ls.get('token')) {
			let key = getRandomAesKey()
			getInfo({ token: ls.get('token'), key })
				.then((res) => {
					if (res.code != 200) {
						removeToken()
						ls.cl()
						this.reload()
					} else {
						setToken(ls.get('token'))
					}
				})
				.catch(() => setToken(ls.get('token')))
		} else {
			removeToken()
		}
	},
	methods: {
		async getDicts() {
			var HOSP_LEVEL = await getDict({ type: 'HOSP_LEVEL' })
			var HOSP_TYPE = await getDict({ type: 'HOSP_TYPE' })
			var HOSP_ADMIN = await getDict({ type: 'HOSP_ADMIN' })
			var baseDepts = await getBaseDepts()
			ls.set('HOSP_LEVEL', HOSP_LEVEL.data)
			ls.set('HOSP_TYPE', HOSP_TYPE.data)
			ls.set('HOSP_ADMIN', HOSP_ADMIN.data)
			ls.set('baseDepts', baseDepts.data)
		},
		reload() {
			this.isRouterAlive = false //先关闭，
			this.$nextTick(function() {
				this.isRouterAlive = true //再打开
			})
		},
	},
}
</script>
<style lang="less">
// @import './style/reset.less';
.hp_flex {
	display: flex;
}
// 水平垂直居中
.hp_center {
	display: flex;
	justify-content: center;
	align-items: center;
}
// 垂直居中
.hp_cz_center {
	display: flex;
	align-items: center;
}
// 水平居中
.hp_sp_center {
	display: flex;
	justify-content: center;
}
// 垂直居中
.hp_cz_center_s {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
// 两侧水平
.hp_space_between {
	display: flex;
	justify-content: space-between;
}
//小手图标
.cursor-point {
	cursor: pointer;
}
//ant-menu
.ant-menu {
	margin: 0 !important;
}
.text-center-g{
	width: 3em;
	text-align: justify;
	text-align-last: justify;
}
</style>
